export default [
  {
    name: 'airlie beach',
    bom: 'http://www.bom.gov.au/products/IDR243.loop.shtml',
    lat: -20.2669485,
    lon: 148.7172492,
  },
  {
    name: 'melbourne',
    bom: 'http://www.bom.gov.au/products/IDR023.loop.shtml',
    lat: -37.813628,
    lon: 144.963058,
  },
  {
    name: 'brisbane',
    bom: 'http://www.bom.gov.au/products/IDR663.loop.shtml',
    lat: -27.469771,
    lon: 153.025124,
  },
  {
    name: 'sydney',
    bom: 'http://www.bom.gov.au/products/IDR713.loop.shtml',
    lat: -33.86882,
    lon: 151.209296,
  },
  {
    name: 'hobart',
    bom: 'http://www.bom.gov.au/products/IDR761.loop.shtml',
    lat: -42.882138,
    lon: 147.327195,
  },
  {
    name: 'perth',
    bom: 'http://www.bom.gov.au/products/IDR703.loop.shtml',
    lat: -31.950527,
    lon: 115.860457,
  },
  {
    name: 'wollongong',
    bom: 'http://www.bom.gov.au/products/IDR033.loop.shtml',
    lat: -34.43,
    lon: 150.88,
  },
  {
    name: 'darwin',
    bom: 'http://www.bom.gov.au/products/IDR633.loop.shtml',
    lat: -12.4612,
    lon: 130.8418,
  },
  {
    name: 'hobart',
    bom: 'http://www.bom.gov.au/products/IDR763.loop.shtml',
    lat: -42.88,
    lon: 147.33,
  },
  {
    name: 'cairns',
    bom: 'http://www.bom.gov.au/products/IDR193.loop.shtml',
    lat: -16.9167,
    lon: 145.7667,
  },
  {
    name: 'gladstone', // for rockhampton
    bom: 'http://www.bom.gov.au/products/IDR233.loop.shtml',
    lat: -23.85,
    lon: 151.25,
  },
  {
    name: 'gympie', // for sunshine coast
    bom: 'http://www.bom.gov.au/products/IDR083.loop.shtml',
    lat: -26.65,
    lon: 153.0667,
  },
  {
    name: 'marburg', // for toowoomba
    bom: 'http://www.bom.gov.au/products/IDR503.loop.shtml',
    lat: -27.55,
    lon: 151.9667,
  },
  {
    name: 'townsville',
    bom: 'http://www.bom.gov.au/products/IDR733.loop.shtml',
    lat: -19.25,
    lon: 146.8,
  },
]
